import {Component, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AdminService} from '@core/services/admin.service';
import {AdminStats} from '@core/models/usuario-sisnot';
import {Skeleton} from 'primeng/skeleton';

@Component({
  selector: 'app-admin-painel',
  imports: [Skeleton],
  templateUrl: './admin-painel.html',
})
export class AdminPainel implements OnInit {
  stats: AdminStats = {totalUsuarios: 0, pendentes: 0, aprovados: 0, recusados: 0};
  loading = true;

  private adminService = inject(AdminService);
  private router = inject(Router);

  ngOnInit() {
    this.adminService.getStats().subscribe({
      next: s => {
        this.stats = s;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  navegarUsuarios() {
    this.router.navigate(['/admin/usuarios']);
  }

  navegarListas() {
    this.router.navigate(['/admin/listas']);
  }

  navegarMetas() {
    this.router.navigate(['/admin/metas']);
  }
}
